import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';



  const Order = () => {
  const [corporateData, setCorporateData] = useState([]);
   const [selectedCorporate, setSelectedCorporate] = useState("");
   const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  // const [selectStatusType, setselectedStatusType] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [Isorder, setIsOrder] = useState(false);
  const [selectOrders, setselectOrders] = useState([]);
  const [PaymentStatus, setPaymentStatus] = useState("");
  const [hasExcel, sethasExcel] =  useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [BCCorporateID, setBCCorporateID] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };
  const handleorderCheckboxChange = (orderId) => {
    setselectOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };

  useEffect(() => {
    const fetchCompanies = async () => {
        try {
          const res = await axios.get(`${GpsBaseURL}/company`,
          {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
              // 'Content-Type' is automatically set by axios when using FormData
            },
          });
          const options = res.data?.data?.map((item) => ({
            value: item._id,
            label: item.company_name,
          }));
          setCompanies(options);
        } catch (error) {
          console.error("Error fetching companies:", error);
        }
    };

    fetchCompanies();
  }, []);

  const handleSelectAll = () => {
    if (selectedOrders.length === filteredData.length) {
      setSelectedOrders([]); // Uncheck all
    } else {
      setSelectedOrders(filteredData.map((user) => user?.user_order_id)); // Select all
    }
  };
  const handleSelectAllOrders = () => {
    if (selectOrders.length === filteredData.length) {
      setselectOrders([]); // Uncheck all
    } else {
      setselectOrders(filteredData.map((user) => user?.user_order_id)); // Select all
    }
  };

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/orders/all-orders-list`);
    }
 document.title = "Success Order";

 const corporateOptions = corporateData.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));

const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption3wrewgfreh", selectedOption);
  if(selectedOption) {
 setSelectedCorporate({ id: selectedOption._id });
  } else {
    setSelectedCorporate(null);
  }
}
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };



  const handlePlaceOrder = async (orderId) => {
  
    // ✅ Step 2: Confirmation popup
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to place this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, place order!",
      cancelButtonText: "Cancel",
    });
  
    if (!confirmResult.isConfirmed) {
      return;
    }
  
    // ✅ Step 3: Show loader
    Swal.fire({
      title: "Processing Order...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      // ✅ Step 4: API Call
      const response = await axios.post(
        `${GpsBaseURL}/order/create-verify-order`,
        {
          order_id: orderId
        },
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );
  
      // Close loader
      Swal.close();
  
      // ✅ Step 5: Success popup
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Order placed successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
  
    } catch (error) {
      Swal.close();
  
      console.error("Error placing order:", error);
  
      // ✅ Step 6: Error popup
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.message || "Failed to place order. Please try again.",
      });
    }
  };



  const fetchproducts = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order`);
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
   
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectedStatusType) queryParams.push(`status=${selectedStatusType}`);
    if(selectedCorporate?.id) queryParams.push(`corporate_id=${selectedCorporate?.id}`);
    if(PaymentStatus) queryParams.push(`payment_status=${PaymentStatus}`);
    if(hasExcel) {queryParams.push(`type=${hasExcel}`)};
    if(fromDate) {queryParams.push(`from_date=${fromDate}`)};
    if(toDate) {queryParams.push(`to_date=${toDate}`)};
    if(isChecked){queryParams.push(`shipping_error_status=${isChecked}`)}
    
    
    
    const apiUrl = `${apiEndpoint}?${queryParams.join('&')}`;
  
    try {
      // const response = await axios.get(apiUrl, {
      //   headers: {
      //     "Content-type": "application/json; charset=UTF-8",
      //     Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
      //   },
      // });
       const data = {
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
              },
            };
      
            if( hasExcel == "excel" ) {
              data.responseType = "blob";
            }
      
            const response = await axios.get(apiUrl, data);

  
      
      if( hasExcel == "excel" ) {
        // Convert response to blob (response.data contains the blob)
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "OrderList.xlsx"; // File name for download
        document.body.appendChild(a);
        a.click();
        sethasExcel("");
        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return ;
      }
  
      console.log("response", response);
     
      setFilteredData(response.data?.data);
      setTotalCount(response.data.totalCount || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchproducts(page);
  }, [searchTerm,  page, hasExcel]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  

  
  const fetchCorporatesData = async () => {
   
    const apiEndpoint = `${GpsBaseURL}/corporate`;
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("Countries response", response);
      setCorporateData(response.data.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
     
    }
  };
useEffect(() => {
    if (Role === "false") {
      fetchCorporatesData();  // Only fetch corporate data if Role === "false"
    }
  }, [Role]);
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order/?page=${page}`;
  //let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
  const params = [];
 
  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedCorporate?.id) {
    params.push(`corporate_id=${selectedCorporate?.id}`);
}
if(selectedStatusType) {
  params.push(`status=${selectedStatusType}`);
}

if(BCCorporateID) {
  params.push(`company_id=${BCCorporateID}`);
}

if(PaymentStatus) {
  params.push(`payment_status=${PaymentStatus}`);
}
if(fromDate) {
  params.push(`from_date=${fromDate}  00:00:00`);
}
if(toDate) {
  params.push(`to_date=${toDate}`);
}

if( isChecked ) {
  params.push(`shipping_error_status=${isChecked}`);
}

  

  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.totalCount); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};

const handleSelectChange = async (meter) => {
  console.log("meterrr", meter);
  
  try {
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait...',
      allowOutsideClick: false,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      didOpen: () => {
        // Swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'The operation was cancelled', 'error');
      }
    });

    Swal.close();
    
    Swal.fire({
      allowOutsideClick: false,
      width: '50%',
      html: `
        <div style="max-width: 100%; overflow-x: auto;">
          <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
            <h4>Product Items</h4>
          </div>
          <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Product Image </th>
                <th>Product Name</th>
               <th>Quantity</th>
                 <th>Price</th>
             </tr>
            </thead>
          <tbody>
      ${
        meter.items?.length > 0 ? 
        meter.items.map((log, index) => {
          return `
            <tr>
              <td>${index + 1}</td>
              <td><img src="${log.product_image}" alt="${log.product_name}" style="max-width: 50px; height: auto;"></td>
              <td>${log?.product_name}</td>
              <td>${log?.quantity}</td>
              <td>${log?.price}
           
         
            </tr>
          `;
        }).join('') : 
        ``
      }
    </tbody>
          </table>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false
    });
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong.',
    });
  }
};
const handleDownloadInvoice = async (e) => {
  e.preventDefault();
  setIsOrder(true);

  if (selectedOrders.length === 0) {
    alert("Please select at least one order.");
    return;
  }

  try {
    const response = await fetch(`${GpsBaseURL}/order/invoice-generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${uniqueToken}`, 
      },
      body: JSON.stringify({ orderIds: selectedOrders }),
    });

    if (!response.ok) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Somthing Went Wrong',
      });
      setIsOrder(false);
      // throw new Error("Failed to generate invoice");
    }

    // Convert response to Blob (for downloading file)
    // const blob = await response.blob();
    // const url = window.URL.createObjectURL(blob);
    
    // // Create a link element to download the file
    // const a = document.createElement("a");
    // a.href = url;
    // a.download = "invoice.pdf"; // Change the filename if needed
    // document.body.appendChild(a);
    // a.click();
    
    // // Clean up
    // window.URL.revokeObjectURL(url);
    // document.body.removeChild(a);
  } catch (error) {
    console.error("Error generating invoice:", error);
    alert("Error generating invoice. Please try again.");
  }
  setIsOrder(false);

};

const handleShipment = async(e) => {
  e.preventDefault();
  setIsOrder(true);

  if (selectOrders.length === 0) {
    alert("Please select at least one order.");
    return;
  }

  try {
    const response = await fetch(`${GpsBaseURL}/order/generate-awb`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${uniqueToken}`, 
      },
      body: JSON.stringify({ orderIds: selectOrders }),
    });
    const responseData = await response.json();
    if (responseData?.statusCode === 200) {
      Swal.fire({
        icon: 'success',  // The icon should be lowercase
        title: responseData?.message,  // No curly braces needed around response?.message
        text: JSON.stringify(responseData?.data, null, 2),  // No curly braces needed around response?.data
      });
    }
    

    if (!response.ok) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Somthing Went Wrong',
      });
      setIsOrder(false);
      // throw new Error("Failed to generate invoice");
    }

 
  } catch (error) {
    console.error("Error generating invoice:", error);
    alert("Error generating invoice. Please try again.");
  }
  setIsOrder(false);
}
const handleDownload = (event) => {
  event.preventDefault()
 sethasExcel("excel");
  
  }


const array = ["a", "b", "c"]
const b = JSON.stringify(array);
for( let i=array.length-1; i>= 0; i-- ) {
  console.log(array[i]);
}
console.log("bbb",b);
console.log("fileteredData", filteredData);
console.log("selectedOrders", selectedOrders);
console.log("selectdddddddorder", selectOrders);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">All Orders({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  
  
</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal w-100" style={{ marginTop: "5px" }}>
    <div className="row px-3 align-items-end">

      {/* Search Input */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>Search</label>
        <input
          type="text"
          placeholder="Find Data Here"
          className="form-control"
          value={searchQuery}
          onChange={handleSearchTextChange}
        />
      </div>

      {/* Corporate Select */}
      {Role === "false" && (
        <div className="col-md-2 col-sm-6 mb-3">
          <label>Corporate</label>
          <Select
            options={corporateOptions}
            onChange={handlecorporateChange}
            value={corporateOptions.find(option => option.value === selectedCorporate?.id) || null}
            placeholder="Corporate"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
                boxShadow: 'none',
              }),
            }}
          />
        </div>
      )}

      {/* Status Select */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>Status</label>
        <select className="form-control" onChange={(e) => setSelectedStatusType(e.target.value)}>
          <option value="">Select Status</option>
          <option value="Pending">Pending</option>
          <option value="Cancelled">Cancelled</option>
          <option value="Placed">Placed</option>
          <option value="Shipped">Shipped</option>
          <option value="Returned">Returned</option>
          <option value="Reinitiate">Reinitiate</option>
        </select>
      </div>

      {/* Payment Status */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>Payment Status</label>
        <select className="form-control" onChange={(e) => setPaymentStatus(e.target.value)}>
          <option value="">Payment Status</option>
          <option value="Pending">Pending</option>
          <option value="Failed">Failed</option>
          <option value="Success">Success</option>
        </select>
      </div>

      {/* From Date */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>From Date</label>
        <input
          type="date"
          className="form-control"
          onChange={(e) => setFromDate(e.target.value)}
        />
      </div>

      {/* To Date */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>To Date</label>
        <input
          type="date"
          className="form-control"
          onChange={(e) => settoDate(e.target.value)}
        />
      </div>

      {/* BC Corporate */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label>BC Corporate</label>
        <Select
          options={companies}
          value={companies.find((opt) => opt.value === BCCorporateID)}
          onChange={(selected) => setBCCorporateID(selected?.value || "")}
          placeholder="Select BC Corporate"
          isClearable
          styles={{
            control: (base) => ({
              ...base,
              height: '38px',
              boxShadow: 'none',
            }),
          }}
        />
      </div>

      {/* Enable Option Checkbox */}
      <div className="col-md-2 col-sm-6 mb-3">
        <label htmlFor="shipmentErrorSelect">Shipment Error</label>
        <select
          id="shipmentErrorSelect"
          className="form-control"
          value={isChecked ? "true" : "false"}
          onChange={(e) => setIsChecked(e.target.value === "true")}
        >
          <option value="false">No</option>
          <option value="true">Yes</option>
        </select>
      </div>



      {/* Buttons */}
      <div className="col-md-4 col-sm-12 d-flex flex-wrap gap-2 mb-3">
        <button className="btn btn-primary" onClick={handleSearchSubmit}>Search</button>
        <button className="btn btn-secondary" onClick={handleReset}>Reset</button>
        <button className="btn btn-success" onClick={handleDownload}>Download</button>

        {selectedOrders.length > 0 && (
          <button
            className="btn btn-primary"
            onClick={handleDownloadInvoice}
            disabled={Isorder}
          >
            {Isorder ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" />
                Loading
              </>
            ) : (
              "Download Invoice"
            )}
          </button>
        )}

        {selectOrders.length > 0 && (
          <button
            className="btn btn-warning"
            onClick={handleShipment}
            disabled={Isorder}
          >
            {Isorder ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" />
                Loading
              </>
            ) : (
              "Shipment"
            )}
          </button>
        )}
      </div>
    </div>
  </form>
</div>




              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
 
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    {Role ==="false" && (
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
  )}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Email</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Mobile</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>OrderID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Price</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment Status</th>
   <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>AWB Date</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>AWB Code</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Serial Number</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Shipment ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Order Date</th>
    <th style={{ minWidth: '180px', whiteSpace: 'nowrap' }}>Action</th>
    
   
  
 
  </tr>
</thead>

        <tbody> 
          {filteredData?.map((user, index) => (
            <tr key={index}>
        

              <td>{(page - 1) * Limit + index + 1}</td>
              {Role ==="false" &&  (
         <td>{user?.corporate_name}</td>
        )}
       <td>{user?.email}</td>
       <td>{user?.mobile}</td>
       <td>  <Link to=""
                                      title="Meter Transaction Logs"
                                      className="transaction-links"   // Specify the route if needed, or leave empty if not using routing
                                      onClick={(e) => {
                                        e.preventDefault();  // Prevents the default link behavior
                                        handleSelectChange(user);
                                      }}
                                    >{user?.orderId}  </Link></td>
                                    <td>{user?.total_price}</td>
                                    <td>{user?.payment_id}</td>
                                    <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.payment_status === 'Pending' ? 'yellow' :
        user?.payment_status === 'Success' ? 'Green' :
        user?.payment_status === 'Failed' ? 'Red' : "purple"
          // Default color
    }}
    className="btn"
  >
    {user?.payment_status}
  </button></td>
      
       <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Cancelled' ? 'Red' :
        user?.status === 'Placed' ? 'green' :
        user?.status === 'Returned' ? '#27B7B7' :
        user?.status === 'Reinitiate' ? '#C86776' :
         user?.status ===  'Shipped' ? 'Orange' : "Purple",  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button></td>
  <td>{user?.awb_date}</td>
  <td>{user?.awb_code}</td>
       
       <td>{user?.serial_number}</td>
       <td>{user?.shipment_id}</td>
       <td>{user?.orderDate}</td>
       <td> &nbsp;&nbsp;&nbsp;&nbsp;
                       <Link to={`/orders/view-order/${user?.user_order_id}`} state={{ OrderEditData: user }}>
                         <i className="fa fa-eye"
                          title="Edit User"
                         ></i>
                       </Link>
                       
                        &nbsp;&nbsp;
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handlePlaceOrder(user?.user_order_id)}
                        >
                          Place Order
                        </button>
        </td>
      
       {/* <td><input type="checkbox"  checked={selectOrders.includes(user?.user_order_id)}
                  onChange={() => handleorderCheckboxChange(user?.user_order_id)}/></td> */}
  </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Order;
